import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Arch, Quadrant, Tooth } from '@libs/ui-lib';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { QuadrantCellComponent } from '../quadrant-cell/quadrant-cell.component';
import { TeethSelectorMode } from '../../teeth-selector-dialog.vm';

@Component({
  selector: 'lib-arch-row',
  standalone: true,
  templateUrl: './arch-row.component.html',
  styleUrl: './arch-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [QuadrantCellComponent, NgClass, TranslateModule],
})
export class ArchRowComponent {
  public readonly teeth = input.required<Tooth[]>();
  public readonly selectedTeethPositions = input.required<number[]>();
  public readonly drawTreatments = input.required<boolean>();
  public readonly arch = input.required<Arch>();
  public readonly leftQuadrant = input.required<Quadrant>();
  public readonly rightQuadrant = input.required<Quadrant>();
  public readonly mode = input.required<TeethSelectorMode>();
  public readonly isSelected = input<boolean>(false);
  public readonly selectedQuadrant = input<Quadrant[]>([]);

  public readonly archClicked = output<Arch>();
  public readonly quadrantClicked = output<Quadrant>();
  public readonly toothClicked = output<number>();

  protected readonly TeethSelectorMode = TeethSelectorMode;

  protected get roundedClasses(): string {
    return this.arch() === 'maxillary' ? 'rounded-b-2xl rounded-t-4xl' : 'rounded-b-4xl rounded-t-2xl';
  }

  protected get paddingClass(): string {
    return this.arch() === 'maxillary' ? 'pb-6' : 'pt-6';
  }

  protected get isClickable(): boolean {
    return this.mode() === TeethSelectorMode.Arch;
  }

  protected get isQuadrantClickable(): boolean {
    return this.mode() === TeethSelectorMode.Quadrant;
  }

  protected get showQuadrantBackground(): boolean {
    return this.mode() === TeethSelectorMode.Quadrant;
  }

  protected onArchClicked(event: MouseEvent): void {
    if (this.isClickable) {
      event.stopPropagation();
      this.archClicked.emit(this.arch());
    }
  }

  protected onQuadrantClicked(quadrant: Quadrant): void {
    if (this.isQuadrantClickable) {
      this.quadrantClicked.emit(quadrant);
    }
  }

  protected onToothClicked(toothPosition: number): void {
    if (!this.isClickable && !this.isQuadrantClickable) {
      this.toothClicked.emit(toothPosition);
    }
  }
}
